module.exports = __webpack_public_path__ + "img/cartaz-mobile.8f16e963.jpg";